import { Award, Check } from 'lucide-react';
import { CATALOGO } from '@/constants/catalogo';
import { SUBMARCAS } from '@/constants/brand';

export default function StepProductos({ quote, setQuote }) {
  const toggle = (id) => {
    const exists = quote.productos.find((p) => p.id === id);
    if (exists) {
      setQuote((q) => ({ ...q, productos: q.productos.filter((p) => p.id !== id) }));
    } else {
      setQuote((q) => ({
        ...q,
        productos: [
          ...q.productos,
          {
            id,
            nombre: CATALOGO[id].nombre,
            configurado: false,
            precioFinal: 0,
            config: {},
          },
        ],
      }));
    }
  };

  const productosOrdenados = Object.keys(CATALOGO).sort(
    (a, b) => CATALOGO[a].orden - CATALOGO[b].orden
  );

  return (
    <div>
      <h2 className="text-xl font-semibold text-white mb-1">Selecciona los productos</h2>
      <p className="text-sm text-neutral-500 mb-6">
        Elige todos los servicios que incluye la propuesta
      </p>

      {quote.productos.length >= 4 && (
        <div className="mb-5 p-4 bg-brand-gold/10 border border-brand-gold/30 rounded-lg flex items-center gap-3">
          <Award className="w-5 h-5 text-brand-gold" />
          <div>
            <div className="text-sm font-medium text-yellow-200">
              ¡Bundle Full Xperience aplicable!
            </div>
            <div className="text-xs text-yellow-200/70">
              Se aplicará 10% de descuento automáticamente
            </div>
          </div>
        </div>
      )}

      <div className="grid grid-cols-2 gap-3">
        {productosOrdenados.map((id) => {
          const p = CATALOGO[id];
          const selected = !!quote.productos.find((pr) => pr.id === id);
          const Icon = p.icon;
          const sub = SUBMARCAS[p.submarca];
          return (
            <button
              key={id}
              onClick={() => toggle(id)}
              className={`text-left p-4 rounded-xl border-2 transition-all ${
                selected
                  ? 'border-brand-gold bg-brand-gold/5'
                  : 'border-neutral-800 bg-neutral-900/30 hover:border-neutral-700'
              }`}
            >
              <div className="flex items-start gap-3">
                <div
                  className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${
                    selected
                      ? 'bg-brand-gold text-black'
                      : 'bg-neutral-800 text-neutral-400'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-white font-semibold text-sm">{p.nombre}</h3>
                    {selected && <Check className="w-4 h-4 text-brand-gold" />}
                  </div>
                  <p className="text-xs text-neutral-400 line-clamp-2 mb-2">{p.descripcion}</p>
                  <span
                    className="text-[10px] px-1.5 py-0.5 rounded font-medium uppercase tracking-wider"
                    style={{ background: `${sub.accent}20`, color: sub.accent }}
                  >
                    {sub.name.replace('Xperience ', 'XP ')}
                  </span>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
